import React from 'react'
import {Hero, Card, Slider, Event} from '../components'
import { GiPathDistance , GiMountainCave} from 'react-icons/gi'
import {RiWalkLine} from 'react-icons/ri'
import useTrip from '../custom/useTrip'
import useTitle from '../custom/useTitle'
import useDescription from '../custom/useDescription'

function HomeScreen() {
    useTitle("Home");
    useDescription("Vivi una fantastica esperienza camminando tra i boschi dei Monti della Laga!");
    const {viaggi} = useTrip();
    return (
        <>
            <Hero overlay>
                <hr/>
                    <div>
                        <h3>Vivi magnifiche esperienze in montagna!</h3>
                    </div>
                <hr/>
            </Hero>
            <div className="card-container">
                <Card title="Percorsi" icon={<GiPathDistance/>} button="/percorsi">
                    <p className="card-text">
                        Vivi una fantastica avventura sui Monti della Laga. Guarda dei bellissimi itinerari che ti porteranno a scoprire le bellezze della natura, sia nel Bosco della Martese che nei picchi Appenninici.
                    </p>
                </Card>
                <Card title="Attrazioni" icon={<GiMountainCave/>} button="/attrazioni">
                    <p className="card-text">
                        Vedi la lista delle Attrazioni Naturalistiche che incontrerai durante i tuoi viaggi a Ceppo. Cascate, Montagne e tanto altro!
                    </p>
                </Card>
                <Card title="Vieni con noi!" icon={<RiWalkLine/>} button="/contattaci">
                    <p className="card-text">
                        Non riesci ad organizzarti per andare a Ceppo? Vieni con noi! Viaggi organizzati ogni fine settimana!
                    </p>
                </Card>
            </div>
            <div>
                <Slider/>
            </div>
            <div className="section-text">
                <h4 className="title" style={{marginBottom:"10px"}}>Prossimi Viaggi</h4>
                <p style={{marginBottom:"10px"}}>Vuoi venire a Ceppo e divertirti insieme ad altri appassionati della montagna? Partecipa ad una delle prossime
                     spedizioni guidate! Controlla se il nostro Autobus passa vicino alla tua cittá, oppure fatti trovare direttamente 
                     a Ceppo all'orario prestabilito.
                     Puoi anche inserire nella prenotazione un pranzo al sacco preparato da noi!
                </p>
                <div className="event-container">
                    {
                        viaggi !== [] ? 
                        viaggi.map(viaggio=>{
                            return <Event key={viaggio.id} {...viaggio}/>
                        })
                        :
                        <p>Nessun Evento disponibile</p>
                    }
                </div>
            </div>
        </>
    )
}

export default HomeScreen
